import { render } from "./StartComponent.vue?vue&type=template&id=77747bbc&scoped=true"
import script from "./StartComponent.vue?vue&type=script&lang=js"
export * from "./StartComponent.vue?vue&type=script&lang=js"

import "./StartComponent.vue?vue&type=style&index=0&id=77747bbc&scoped=true&lang=css"

import exportComponent from "D:\\Programas\\laragon\\www\\projects\\vuejs\\adivina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77747bbc"]])

export default __exports__